import { render } from "./DataDuration.vue?vue&type=template&id=32105f24"
import script from "./DataDuration.vue?vue&type=script&lang=js"
export * from "./DataDuration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__